import { ModalResult } from "@app/state/constants";

import type { TBlueObj } from "@app/types/insider";
import type { Result } from "starfx";

const REPO_NAME = "notify";
export const notifyRepo: TBlueObj<{ message: string }> = {
  name: REPO_NAME,
  initialState: {
    message: "",
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};

export type TDialogs = {
  name:
    | "DBVALIADATION-OF-1"
    | "DBVALIADATION-OF-2"
    | "DBVALIADATION-OF-3"
    | "DBVALIADATION-OF-4"
    | "DBVALIADATION-OF-5"
    | "DBVALIADATION-OF-6"
    | "DBVALIADATION-OF-7"
    | null
    | never;
  result: null | ModalResult;
  params: Record<string, unknown>;
};

export const dialogs: TBlueObj<TDialogs> = {
  name: "dialogs",
  initialState: {
    name: null,
    result: null,
    params: {},
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
